import gql from 'graphql-tag';

export const currencyFragments = gql`
  fragment currencyFragments on Currency {
    name
    code
  }
`;

export const ALL_CURRENCIES = gql`
  query allCurrencies {
    allCurrencies {
      ...currencyFragments
    }
  },
  ${currencyFragments}
`;
